module.exports = __webpack_public_path__ + "static/woodbrook-f8b5ae60d7bb424cbee5ea57d0f0e380.jpg";